import { translateFn } from '../../../../../../../utils/translator.helper';
import { RequiredValidator } from '../../../../../../../ui/gzForm/validators/required.validator';
import { FormValidator, ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { IpValidator } from '../../../../../../../ui/gzForm/validators/ip.validator';
import { FirewallNetworkIdentification, FirewallNetworkItem } from '@nirvana/shared/dtos/types/policies/common';
import { MacValidator } from '../../../../../../../ui/gzForm/validators/mac.validator';

// get validators for network field
export const networkValidators = (): FormValidator<string>[] => {
  return [RequiredValidator(translateFn('Required field'))];
};

// get validators for type field
export const typeValidators = (): FormValidator<string>[] => {
  return [RequiredValidator(translateFn('Required field'))];
};

// get validators for identification field
export const identificationValidators = (): FormValidator<string>[] => {
  return [RequiredValidator(translateFn('Required field'))];
};

// get validators for mac field
export const macValidators = (): FormValidator<string>[] => {
  return [RequiredValidator(translateFn('Required field')), MacValidator(translateFn('Invalid MAC address'))];
};

// get ip validator for ip field
export async function ipValidatorByIdentification(
  value: string,
  identification?: FirewallNetworkIdentification
): Promise<ValidationResult> {
  return await IpValidator(
    translateFn('Invalid IP/mask format'),
    true,
    identification === FirewallNetworkIdentification.NETWORK
  )(value);
}

// validate network duplicates
export function validateNetworkDuplicates(
  item: FirewallNetworkItem,
  itemsInGrid: FirewallNetworkItem[]
): ValidationResult {
  const hasDuplicates = itemsInGrid.some((itemInGrid: FirewallNetworkItem) => itemInGrid.network === item.network);

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}

// validate identification duplicates
export function validateIdentificationDuplicates(
  item: FirewallNetworkItem,
  itemsInGrid: FirewallNetworkItem[]
): ValidationResult {
  const hasDuplicates = itemsInGrid.some(
    (itemInGrid: FirewallNetworkItem) =>
      itemInGrid.identification === item.identification &&
      itemInGrid.domainMac === item.domainMac &&
      itemInGrid.ip === item.ip
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
